module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'VISA') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Help with your visa application file 120€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Help with your visa application file.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals 299€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'TA') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Appeal to the Administrative Court of Nantes 299€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("appeal to the Administrative Court of Nantes.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Premium Pack 999€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("You are assisted and defended by a specialised lawyer..")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/lawyer.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("We send you the details of the procedure an the mounts by email once you accept the engagement conditions")]), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onClickPay()
      }
    }
  }, [_c('span', [_vm._v("Pay")])])], 1)])], 1) : _c('div', [_c('h2', [_vm._v("Waiting for the Western Union transfer")]), _vm._v(" "), _c('p', [_vm._v("A confirmation email has just been sent to you")]), _c('p'), _c('p', [_vm._v("Once the Western Union transfer made, please follow the instructions we sent you by email \n        to enter the transfer number (MTCN) in order to finish to constitute your file.")]), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickContinue()
      }
    }
  }, [_vm._v("Continue")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "40%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/western-union.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('h2', [_vm._v("Payment by Western Union")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you click on the “pay” button you accept to go  "), _c('u', [_vm._v("in a Western Union insitute")]), _vm._v(" to make a transfer to the legal representative of OCTAGRAM SAS company, GetMyVIsaToFrance oprator :")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('b', [_vm._v("Firstname : Alexandre, René, Georges")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last name : GRUX")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1bd0fc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutWesternUnion.vue
// module id = 728
// module chunks = 3